import { ERouteContext } from './types';
import { createStoreRoutes } from './utils/storeLevelRoutesUtil';

const portalLevelStoreRoutes = (defaultStorePage: string) => {
  return createStoreRoutes(
    'store/:publisherId',
    defaultStorePage,
    ERouteContext.PORTAL_LEVEL_STORE,

  );
};

export default portalLevelStoreRoutes; 